import React, { useState, useEffect, Fragment } from "react";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { FormControlLabel, Grid, TextField, IconButton, Badge, Typography, Drawer, FormControl, Button } from "@material-ui/core";
import ChangeViewArray from '../ChangeViewArray';
import FilterIcon from '../../icons/FilterIcon';
import DevDynTable from "./DevDynTable";
import DevDynTile from "./DevDynTile";
import VersionPlanDrawer from './VersionPlanDrawer';
import { useParams } from "react-router-dom"
import axios from 'axios';
import SkeletonCardTable from '../Skeleton/SkeletonCardTable';
import SkeletonCardTile from '../Skeleton/SkeletonCardTile';
import SubFilterList from '../SubFilterListVers3';
import ChipArrayRed from '../ChipArrayRed';
import CloseIcon from '../../icons/CloseIcon';
import CustomCheckbox from "../CustomCheckbox";
import translate from '../../other/translate.json';
import Pagination from '@material-ui/lab/Pagination';
import Tooltip from '@material-ui/core/Tooltip';
import FilterErr from "../Errors/FilterErr";
import config from '../../other/config';

const FilterButton = withStyles({
	root: {
		width: '100%',
		borderRadius: '48px',
		boxShadow: 'none',
		textTransform: 'none',
		fontSize: '18px',
		border: 'none',
		lineHeight: '39px',
		backgroundColor: '#8987A2',
		borderColor: '#0063cc',
		fontFamily: 'Cera CY',
		color: '#FFFFFF',
		fontStyle: 'normal',

		'&:hover': {
			backgroundColor: '#8987A2',
		},
	},
})(Button);

export default function DevDynContent(props) {
	const {serverAPI} = config;
	var d = new Date();
	var year = d.getFullYear();
	var month = d.getMonth()//.length > 1 ? d.getMonth() : `0${d.getMonth()}`;
	var day = d.getDate();
	var fulldate = new Date(year - 1, month, day);
	var fullDateNext = new Date(year + 1, month, day);
	let { language } = props
	const classes = useStyles();
	const [filterOpen, setFilterOpen] = useState(false);
	const [sectionArr, setSectionArr] = useState([]);
	const [dynamicsArr, setDynamicsArr] = useState([]);
	const [screenVersionBeforeVisible, setScreenVersionBeforeVisible] = useState(false);
	const [versionArr, setVersionArr] = useState([]);
	const [directionArr, setDirectionArr] = useState([]);
	const [selectedDateFrom, handleDateChangeFromVal] = useState(fulldate);
	const [selectedDateTo, handleDateChangeToVal] = useState(fullDateNext);
	const [screenSectionVisible, setScreenSectionVisible] = useState(false);
	const [screenDirectionVisible, setScreenDirectionVisible] = useState(false);
	const [loading, setloading] = useState(true);
	let [view, _view] = useState(localStorage.getItem('view') || 'table')
	let [statusFilter, setStatusFilter] = useState(false);
	let [first, setFirts] = useState(false);
	let { bank } = useParams();
	let [idsDirection, _idsDirection] = useState([]);
	let [idsSection, _idsSection] = useState([]);
	let [idsVersion, _idsVersion] = useState([]);
	let [datefrom, _datefrom] = useState(`${year - 1}-${month > 8 ? '' : '0' }${month+1}-${day}`);
	let [dateto, _dateto] = useState('');
	let [archive, _archive] = useState(0);
	let [count, setCount] = useState(0);
	let [page, setPage] = useState(1);

	function setView(view) {
		_view(view)
		localStorage.setItem('view', view)
	}

	function changePage(event, value) { // codeerr где value??????
		setPage(value);
	};

	useEffect(() => {
		setStatusFilter(idsSection.length > 0 || idsVersion.length > 0 || idsDirection.length > 0 || +archive);
		let didCancel = false;
		async function fetchData() {
			let idsDirectionM = idsDirection.map(el => el.ID_BN)
			let idsVersionM = idsVersion.map(el => el.ID)
			const dataDynamicsSection = await axios.get(`${serverAPI}/dynamics/${language}?archive=${archive}&systema=${bank}&page=${page - 1}&countRecord=24&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&datefrom=${datefrom}&dateto=${dateto} `)
			if (!didCancel) {
				if (dataDynamicsSection && dataDynamicsSection.data) {
					setloading(false)
					setDynamicsArr(dataDynamicsSection.data.map(el => {try{el.additional_versions = JSON.parse(el.additional_versions)} catch (e) { el.additional_versions = []} return el}))
					setCount((dataDynamicsSection.data && dataDynamicsSection.data[0] && dataDynamicsSection.data[0].count) || 0)
				}
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		};
	}, [datefrom, dateto, idsSection, idsDirection, idsVersion, archive, page]);



	const handleDateChangeTo = (date) => {
		handleDateChangeToVal(date)
		setStatusFilter(true)
		setPage(1)

		_dateto(date.format('YYYY-MM-DD'))
		if (date < selectedDateFrom) {
			_datefrom(date.format('YYYY-MM-DD'))
			handleDateChangeFromVal(date)
		}
	}

	const handleDateChangeFrom = (date) => {
		setStatusFilter(true)
		setPage(1)

		// setListNum(0)
		_datefrom(date.format('YYYY-MM-DD'))
		handleDateChangeFromVal(date)
		if (date > selectedDateTo) {
			_dateto(date.format('YYYY-MM-DD'))
			handleDateChangeToVal(date)
		}
		if (date < fulldate) {
			_archive('1')
		} else {
			_archive('0')
		}


		// 
	}
	const setScreenVersionBeforeVisibleProps = () => {
		setScreenVersionBeforeVisible(!screenVersionBeforeVisible)
	}

	const handleStrockList = (index) => {
		// setSelectedIndex(index);
		setView(index)
	};



	useEffect(() => {
		if (first === false) { setFirts(true) }
		let didCancel = false;
		async function fetchData() {
			const dataAllSection = await axios.get(`${serverAPI}/dynamics_section/${language}?systema=${bank}&datefrom=${datefrom}&dateto=${dateto}`)
			const dataAllBn = await axios.get(`${serverAPI}/dynamics_direction/${language}?systema=${bank}&datefrom=${datefrom}&dateto=${dateto}`) /** */
			const dataAllVersion = await axios.get(`${serverAPI}/dynamics_version/${language}?systema=${bank}&datefrom=${datefrom}&dateto=${dateto}`)
			if (!didCancel) {
				if (dataAllBn.data)
					setSectionArr(dataAllSection.data)
				setDirectionArr(dataAllBn.data)
				setVersionArr(dataAllVersion.data)
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		};

	}, [datefrom, dateto]);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			setPage(1)
			let idsDirectionM = idsDirection.map(el => el.ID_BN)
			let idsVersionM = idsVersion.map(el => el.ID)
			const dataAllVersion = await axios.get(`${serverAPI}/dynamics_version/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`)
			const dataAllBn = await axios.get(`${serverAPI}/dynamics_direction/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`) /** */
			if (!didCancel) {
				if (dataAllBn.data)
					setDirectionArr(dataAllBn.data)
				setVersionArr(dataAllVersion.data)
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		};
	}, [idsSection]);


	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			let idsDirectionM = idsDirection.map(el => el.ID_BN)
			let idsVersionM = idsVersion.map(el => el.ID)
			const dataAllVersion = await axios.get(`${serverAPI}/dynamics_version/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`)
			const dataAllSection = await axios.get(`${serverAPI}/dynamics_section/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`)
			if (dataAllVersion.data) {
				setSectionArr(dataAllSection.data)
				setVersionArr(dataAllVersion.data)
			}
			if (idsDirection.length === 0) {
				const dataAllBn = await axios.get(`${serverAPI}/dynamics_direction/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`) /** */
				if (dataAllBn.data) {
					setDirectionArr(dataAllBn.data)
				}
			}
		}
		if (!didCancel) {
			setPage(1)
		}
		fetchData();
		return () => {
			didCancel = true;
		};


	}, [idsDirection]);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			let idsVersionM = idsVersion.map(el => el.ID)
			let idsDirectionM = idsDirection.map(el => el.ID_BN)
			// idsVersion && idsVersion.length > 0 ? idsVersionM = idsVersion.replace(/^\,/, '').replace(/\,$/, '') : idsVersionM = ''

			const dataAllBn = await axios.get(`${serverAPI}/dynamics_direction/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`)
			const dataAllSection = await axios.get(`${serverAPI}/dynamics_section/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`)
			if (idsVersion.length === 0) {
				const dataAllVersion = await axios.get(`${serverAPI}/dynamics_version/${language}?systema=${bank}&datefrom=${datefrom}&sections=${idsSection.map(el => el.ID)}&directions=${idsDirectionM}&versions=${idsVersionM}&dateto=${dateto}`)
				setVersionArr(dataAllVersion.data)
			}
			if (!didCancel) {
				setPage(1)
				if (dataAllBn.data)
					setSectionArr(dataAllSection.data)
				setDirectionArr(dataAllBn.data)
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		};

	}, [idsVersion]);

	useEffect(() => {
		if (window.innerWidth < 1366 && view === 'table') {
			// setSelectedIndex(0)
			setView('tile')
		}
	}, [window.innerWidth]);

	function resetState() {
		handleDateChangeFromVal(fulldate);
		handleDateChangeToVal(fullDateNext);
		_datefrom(`${year - 1}-${month}-${day}`);
		_dateto(fullDateNext);
		_idsSection([])
		_idsDirection([])
		_idsVersion([])
		_archive(0)
		setPage(1)
		setStatusFilter(false)
	}

	function setVersBefore(ids) {
		setPage(1)
		if (idsVersion.length > 0 && idsVersion.some(el => el.ID === ids.ID)) {
			_idsVersion(idsVersion.filter(el => el.ID !== ids.ID))
		} else {
			_idsVersion(idsVersion.concat([ids]))
		}
	}

	function setIdsDirection(ids) {
		setPage(1)
		if (idsDirection.length > 0 && idsDirection.some(el => el.ID_BN === ids.ID_BN)) {
			_idsDirection(idsDirection.filter(el => el.ID_BN !== ids.ID_BN))
		} else {
			_idsDirection(idsDirection.concat([ids]))
		}

	}

	function setIdsSection(ids) {
		setPage(1)
		if (idsSection.some(el => el.ID === ids.ID)) {
			_idsSection(idsSection.filter(el => el.ID !== ids.ID))
		} else {
			_idsSection(idsSection.concat([ids]))
		}
	}
	function changeVal(turn) {
		setPage(1)
		if (turn === 1) {
			var fulldates = new Date(2011, 1, 1);
			_archive('1'); _datefrom(`${year - 100}-${month}-${day}`);
			handleDateChangeFromVal(`${fulldates}`)

		} else {
			_archive('0'); _datefrom(`${year - 1}-${month}-${day}`);
			handleDateChangeFromVal(fulldate)
		}

	}
	function FilterHeader() {
		return (
			<Grid container direction="row" justify="space-between" alignItems="center" style={{ padding: '12px 12px 12px 24px' }} /* style={{ position: 'fixed', width: 334, background: '#FFF', paddingTop: 32, paddingLeft: 24, zIndex: 2 }} */>
				<Grid item>
					<Typography className={classes.filterHeader}>
						{translate.Words[`Filter${language}`]}
					</Typography>
				</Grid>

				<Grid item className={classes.btnClose}>
					<IconButton onClick={() => setFilterOpen(false)} aria-label="filter">
						<CloseIcon fill='#BCBBD0' />
					</IconButton>
				</Grid>
			</Grid>)
	};


	return (
		<React.Fragment>
			<Grid container spacing={3} style={{ paddingTop: 44 }}>
				<Grid item container>
					<Grid item container>
						<Grid
							item
							container
							direction="row"
							className={classes.search}
							style={{ flexGrow: 1, }}
						>
							{/* <VersionPlanDrawer lang={language} /> */}
						</Grid>

						<Grid item className={classes.cntrChangeView}>
							<ChangeViewArray selected={view === 'tile' ? 1 : 0} handleView={handleStrockList} />
						</Grid>

						{/* ===== ФИЛЬТРЫ =============== */}

						<Grid item>
							<CustomTooltip title={language === 'Ru' ? 'Фильтр' : "Filter"}>
								<IconButton onClick={() => setFilterOpen(true)} aria-label="filter" className={classes.btnFilter}>
									{statusFilter ?
										<StyledBadge
											color="secondary"
											variant="dot"
										>
											<FilterIcon />
										</StyledBadge>
										:
										<FilterIcon />}
								</IconButton>
							</CustomTooltip>

							<Drawer
								anchor={"right"}
								open={filterOpen}
								onClose={() => setFilterOpen(false)}
							>
								<Grid item className={classes.FilterHeaderCntr} style={{ width: 334 }}>
									{FilterHeader()}
								</Grid>

								<Grid style={{ height: 'calc(100% - 108px)', overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}>
									<Grid item container direction="column" style={{ padding: '0 24px', height: '100%' }}>
										<Grid item container direction="column" className={classes.FilterBodyCntr}>
											<FormControl component="fieldset" style={{ maxWidth: 285, width: '100%' }}>
												<Typography className={classes.header}>{translate.Words[`Version${language}`]}:</Typography>
												<SubFilterList data={versionArr} ids={idsVersion} key1={'ID'} key2={'Version'} setBefore={setVersBefore} header={translate.Words[`Version${language}`]} paramName='version' close={setScreenVersionBeforeVisibleProps} />
												<Grid item style={{ paddingTop: 8 }}>
													<ChipArrayRed chipData={idsVersion} key1={'ID'} key2={`Version`} handleDelete={setVersBefore} />
												</Grid>
											</FormControl>

											<FormControlLabel
												control={<CustomCheckbox checked={archive === '1'} onChange={() => { archive === '1' ? changeVal(0) : changeVal(1) }} />}
												label={translate.Words[`ShowInArchive${language}`]}
												className={classes.FClabel}
											/>

											<FormControl component="fieldset" style={{ maxWidth: 285, width: '100%' }}>
												<Typography className={classes.header}>{translate.Words[`BusinessArea${language}`]}:</Typography>
												<SubFilterList data={directionArr} ids={idsDirection} key1={'ID_BN'} key2={`TitleDirectionRu`} setBefore={setIdsDirection} header={translate.Words[`BusinessArea${language}`]} paramName='direction' close={() => setScreenDirectionVisible(!screenDirectionVisible)} />
												<Grid item style={{ paddingTop: 8 }}>
													<ChipArrayRed chipData={idsDirection} key1={'ID_BN'} key2={`TitleDirection${language}`} handleDelete={setIdsDirection} />
												</Grid>
											</FormControl>

											<FormControl component="fieldset" style={{ maxWidth: 285, width: '100%' }}>
												<Typography className={classes.header}>{translate.Words[`Section${language}`]}:</Typography>
												<SubFilterList data={sectionArr} ids={idsSection} key1={'ID'} key2={`TitileSectionRu`} setBefore={setIdsSection} header={translate.Words[`Sections${language}`]} paramName='section' close={() => setScreenSectionVisible(!screenSectionVisible)} />
												<Grid item style={{ paddingTop: 8 }}>
													<ChipArrayRed chipData={idsSection} key1={'ID'} key2={`TitileSectionRu`} handleDelete={setIdsSection} />
												</Grid>
											</FormControl>

											<Grid container justify="space-between" style={{ marginTop: 20, marginBottom: -6 }}>
												<Fragment>
													<MuiPickersUtilsProvider utils={MomentUtils} locale={language}>
														<DatePicker
															autoOk
															variant="inline"
															inputVariant="outlined"
															label={translate.Words[`To${language}1`]}
															format="DD/MM/yyyy"
															value={selectedDateFrom}
															InputAdornmentProps={{ position: "start" }}
															onChange={date => handleDateChangeFrom(date)}
															style={{
																width: '132px',
																borderBottomColor: '#F6F6FB',
																backgroundColor: '#F6F6FB',
																border: 'none'
															}}
														/>

														<DatePicker
															autoOk
															variant="inline"
															inputVariant="outlined"
															label={translate.Words[`To${language}2`]}
															format="DD/MM/yyyy"
															value={selectedDateTo}
															InputAdornmentProps={{ position: "start" }}
															onChange={date => handleDateChangeTo(date)}
															style={{
																width: '132px',
																borderBottomColor: '#F6F6FB',
																backgroundColor: '#F6F6FB',
																border: 'none'
															}}
														/>
													</MuiPickersUtilsProvider>
												</Fragment>
											</Grid>
										</Grid>



										<Grid item className={classes.FilterActionCntr}>
											<FilterButton variant="contained" className={classes.btnSecondary} onClick={() => resetState()}>{translate.Words[`ResetFilters${language}`]} </FilterButton>
										</Grid>

										{/* <FilterListDynamics
											IsRu={language === 'Ru'}
											lang={language}
											_archive={_archive}
											archive={archive}
											resetState={resetState}
											setFilterOpen={setFilterOpen}
											setScreenVersionBeforeVisible={setScreenVersionBeforeVisible}
											screenVersionBeforeVisible={screenVersionBeforeVisible}
											chipVersion={chipVersion}
											handleDeleteVers={handleDeleteVers}
											versionArr={versionArr}
											idsVersion={idsVersion}
											setVersBefore={setVersBefore}
											setScreenVersionBeforeVisibleProps={setScreenVersionBeforeVisibleProps}
											selectedDateFrom={selectedDateFrom}
											handleDateChangeFrom={handleDateChangeFrom}
											selectedDateTo={selectedDateTo}
											handleDateChangeTo={handleDateChangeTo}
											setScreenDirectionVisible={setScreenDirectionVisible}
											screenDirectionVisible={screenDirectionVisible}
											chipDirection={chipDirection}
											handleDeleteDirection={handleDeleteDirection}
											setScreenSectionVisible={setScreenSectionVisible}
											directionArr={directionArr}
											idsDirection={idsDirection}
											setIdsDirection={setIdsDirection}
											setScreenDirectionVisibleProps={setScreenDirectionVisibleProps}
											chipSelect={chipSelect}
											handleDeleteSelect={handleDeleteSelect}
											screenSectionVisible={screenSectionVisible}
											sectionArr={sectionArr}
											idsSection={idsSection}
											setIdsSection={setIdsSection}
											setScreenSectionVisibleProps={setScreenSectionVisibleProps}
										/> */}
									</Grid>
								</Grid>
							</Drawer>
						</Grid>

						{/* =============== ФИЛЬТРЫ ===== */}

					</Grid>
				</Grid>

				<Grid item container spacing={3} style={{ marginTop: 12 }}>
					{view === 'tile'
						?
						loading === true
							?
							<SkeletonCardTable />
							:
							dynamicsArr.length > 0
								?
								<DevDynTable
									type={'applications'}
									// basketChips={basketChips} 
									// setAppBasket={setAppBasket} 
									IsRu={props.IsRu}
									readLink={true}
									cardArr={dynamicsArr}
									basket={false}
								/>
								:
								<FilterErr />
						:
						loading === true
							?
							<SkeletonCardTile />
							:
							dynamicsArr.length > 0
								?
								<DevDynTile
									type={'applications'}
									language={language}
									// basketChips={basketChips} 
									// setAppBasket={setAppBasket} 
									IsRu={props.IsRu}
									readLink={true}
									cardArr={dynamicsArr}
									basket={false}
								/>
								:
								<FilterErr />
					}
				</Grid>
				<Grid item container style={{ display: Math.trunc((count - 1) / 24) > 0 ? '' : 'none', marginTop: 24, paddingLeft:1,alignItems: 'center' }} >
					<Pagination className={classes.newPagination}  count={Math.trunc((count - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
				</Grid>
				<Grid item id = 'paginationContainer-js' container style={{ display: Math.trunc((count - 1) / 24) > 0 ? '' : 'none', marginTop: 24,  height:  64, position: 'fixed' , bottom:'0px',background: '#F4F5FB', paddingLeft:1,alignItems: 'center'}} >
					<Pagination className={ classes.newPagination } count={Math.trunc((count - 1) / 24) + 1} siblingCount={window.innerWidth < 696 ? 0 : 1} page={page} onChange={changePage} />
				</Grid>
					
			</Grid>
		</React.Fragment>
	);
}

const CssTextField = withStyles({
	root: {
		'& .MuiFilledInput-root': {
			backgroundColor: '#F6F6FB',
			border: 'none',
			borderRadius: '4px'
		},
		'& label.Mui-focused': {
			color: '#8987A2',
		},
		'& .MuiFilledInput-underline:before': {
			border: 'none',
		},
		'& .MuiFilledInput-underline:after': {
			border: 'none',
		},
	},
})(TextField);

const StyledBadge = withStyles((theme) => ({
	badge: {
		top: 32,
		right: -6,
		height: 10,
		width: 10,
		borderRadius: 5,
		backgroundColor: '#EB505E'
	},
}))(Badge);

const useStyles = makeStyles(theme => ({
	// root: {
	// 	display: "flex"
	// },
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	content: {
		flexGrow: 1,
		padding: 0,
		paddingTop: theme.spacing(3),
		marginTop: theme.spacing(12),
		// backgroundColor: 'inherit'
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	container: {
		margin: '72px auto 0',
		'&:first-child': {
			margin: '0 auto'
		},
		[theme.breakpoints.down(696)]: {
			maxWidth: 'calc(336px * 1)',
		},
		[theme.breakpoints.between(696, 1030)]: {
			maxWidth: 'calc(336px * 2)',
		},
		[theme.breakpoints.between(1030, 1366)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.between(1366, 1702)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.up(1702)]: {
			maxWidth: 'calc(336px * 4)',
		}
	},

	containerImage: {
		[theme.breakpoints.down(1702)]: {
			minWidth: '100%',
		},
	},

	containerInfo: {
		[theme.breakpoints.down(1702)]: {
			display: 'none',
		},
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemText: {
		padding: theme.spacing(1, 1)
	},

	paper: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2)
	},

	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},

	imgCntr: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		backgroundImage: 'url(./images/BannerDesctop.png)',
		borderRadius: 24
	},

	footer: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '36px 0'
	},

	btnFilter: {
		backgroundColor: '#FFF',
		borderRadius: '16px',
		'&:focus': {
			borderRadius: '16px'
		}
	},

	tHeader: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		fontWeight: 400
	},

	backToList: {
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	search: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: 'auto',
		height: 48,

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},

	inputRoot: {
		color: '#8987A2',
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
		transition: theme.transitions.create('width'),
		width: 232,
		height: 32,
		[theme.breakpoints.down(1366)]: {
			// width: 0,
			'&:focus': {
				width: 207,
			},
		},
		color: '#8987A2'
	},

	filterHeader: {
		fontWeight: 500,
		fontSize: '24px',
		lineHeight: '32px',
		color: '#24262A'
	},

	FilterBodyCntr: {
		height: 'calc(100% - 75px)',
		overflowX: 'hidden',
		overflowY: 'auto',
		width: 285,
		flexFlow: 'column',
		scrollbarWidth: 'thin'
	},

	header: {
		marginTop: 20,
		marginBottom: 10,
		fontWeight: 500,
		fontSize: '18px',
		lineHeight: '28px',
		color: '#24262A'
	},

	FilterActionCntr: {
		padding: '24px 0 0 0'
	},

	FClabel: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2'
	},

	root: {
		flexGrow: 1
	},
	padding: {
		padding: theme.spacing(1)
	},
	demo1: {
		backgroundColor: theme.palette.background.paper
	},
	demo2: {
		backgroundColor: "#2e1534"
	},

	cntrAppCardTop: {
		padding: '36px 0'
	},

	cntrChangeView: {
		marginRight: 23,

		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	},
	newPagination :{
		display:'flex',
		alignItems:'center'
	}
}));

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);